import 'whatwg-fetch';
import vue from '@/libs/bus';


/**
 * 设置当前会话就诊卡，附带校验
 */
const setCurrentCardWithValidate = async function (vueComponent) {
    const patientName = validateParam(vueComponent.$route.query.patientName); // 获取url参数: 患者姓名 
    const innerCardNumber = validateParam(vueComponent.$route.query.cardNumber); // 获取url参数: 就诊卡号 
    const innerPatientId = validateParam(vueComponent.$route.query.patientId); // 获取url参数: 患者唯一标识 
    const officialAccountToken = validateParam(vueComponent.$route.query.token); // 获取url参数: 公众号令牌 

    if (!innerCardNumber || !innerPatientId) {
        return false;
    }

    const accessToken = localStorage.getItem('accessToken');
    try {
        const respData = await vue.$http.post(
            '/cloud-film-api/webapi/current-card/set-current-card-with-validate',
            {
                patientName: patientName,
                innerCardNumber: innerCardNumber,
                innerPatientId: innerPatientId,
                officialAccountToken: officialAccountToken,
            },
            {
                Authorization: `Bearer ${accessToken}`,
            }
        );
        if (!respData.success) {
            vue.$toast.fail('关联就诊卡失败，' + respData.msg);
            console.error('关联就诊卡失败，' + respData.msg);
        }
        return respData.data;
    } catch (error) {
        console.error('请求创建失败:', error);
        return error;
    }
}

/**
 * 参数验证 - 防止XSS攻击和确保必要参数存在
 * @param param
 * @returns {*}
 */
const validateParam = (param) => {
    if (param && typeof param === 'string') {
        // 移除潜在危险字符
        return param.replace(/[<>'"&]/g, '');
    }
    return param;
};

/**
 * 填充当前就诊卡
 * @param list 原就诊卡列表
 * @returns {Promise<*>}
 */
const getCurrentCard = function () {
    const accessToken = localStorage.getItem('accessToken');
    return vue.$http.get('/cloud-film-api/webapi/current-card/get-current-card', {}, {Authorization: `Bearer ${accessToken}`});
}


/**
 * 添加就诊卡到列表中
 */
const addCard = function (bindCardList, currentCard) {
    if (currentCard == null) {
        //没有当前就诊卡直接返回绑卡列表
        return bindCardList;
    }
    const cardList2 = [];
    //当前就诊卡放在最前面
    currentCard = fixBindCardProp(currentCard);
    cardList2.push(currentCard)
    for (let i = 0; i < bindCardList.length; i++) {
        const bindCard = bindCardList[i];
        //如果当前就诊卡和当前列表中的某一个匹配，则替换
        if (bindCard.medical_card_id === currentCard.innerCardNumber) {
            bindCard.name = currentCard.name
            bindCard.hospital_id = currentCard.hospitalId
            cardList2[0] = bindCard;
        }else {
            //绑卡列表与当前就诊卡不匹配的直接添加到列表中
            cardList2.push(bindCard);
        }
    }
    return cardList2;
}

/**
 * 修复当前就诊卡的属性，使用他和绑卡关键属性一致
 */
function fixBindCardProp(currentCard) {
    currentCard.medical_card_id = currentCard.innerCardNumber;
    currentCard.hospital_id = currentCard.hospitalId;
    currentCard.hospital_flag = currentCard.hospitalName;
    return currentCard;
}


/**
 * 加载就诊卡，包括绑卡列表和当前会话就诊卡
 */
const listCards = function (params, headers) {
    headers == null && (headers = {});
    let bindCardPromise = vue.$http.get('/patient-api/webapi/user/list-medical-card', params , headers, false);
    //填充当前会话就诊卡
    let currentCardPromise = getCurrentCard();
    return Promise.all([bindCardPromise, currentCardPromise]).then(([bindCardRespData, currentCardRepsData]) => {
        return addCard(bindCardRespData.list, currentCardRepsData.data);
    });
}

export default {
    setCurrentCardWithValidate,
    getCurrentCard,
    addCard,
    listCards
}